/*
 * @Author: Sky
 * @Date: 2024-09-23 09:19:22
 * @LastEditors: Sky
 * @LastEditTime: 2024-09-25 11:22:49
 * @Description: desc
 */
export default {
	path: '/',
	icon: '',
	component: '',
	meta: {
		title: '固定资产'
	},
	children: [
		{
			path: '/order/handout-xingzheng',
			name: 'HandoutXingzhengIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/order/educationalAdministration/handout-xingzheng'),
			meta: {
				title: '讲义管理'
			}
		},
		{
			path: '/',
			icon: '',
			component: '',
			meta: {
				title: '资产管理'
			},
			children: [
				{
					path: '/assets/assetRepository',
					name: 'assetRepository',
					icon: '',
					component: () => import('@/views/assets/assetRepository/index'),
					power: 'admin/v1/assetRepository',
					meta: {
						title: '资产库'
					}
				},
				{
					path: '/assets/assetAdd',
					name: 'assetAdd',
					icon: '',
					component: () => import('@/views/assets/assetAdd/index'),
					power: 'admin/v1/assetAdd',
					meta: {
						title: '资产录入'
					}
				},
				{
					path: '/assets/receiveReturn',
					name: 'assetReceiveReturn',
					icon: '',
					component: () => import('@/views/assets/receiveReturn/index'),
					power: 'admin/v1/receiveReturn',
					meta: {
						title: '资产领用&退还'
					}
				},
				{
					path: '/assets/borrowBack',
					name: 'borrowBack',
					icon: '',
					component: () => import('@/views/assets/borrowBack/index'),
					power: 'admin/v1/borrowBack',
					meta: {
						title: '资产借用&归还'
					}
				},
				{
					path: '/assets/assetAlter',
					name: 'AssetAlterIndex',
					icon: '',
					component: () => import('@/views/assets/assetAlter/index'),
					power: 'admin/v1/assetAlter',
					meta: {
						title: '资产变更'
					}
				},
				{
					path: '/assets/assetAllot',
					name: 'AssetAllotIndex',
					icon: '',
					component: () => import('@/views/assets/assetAllot/index'),
					power: 'admin/v1/assetAllot',
					meta: {
						title: '资产调拨'
					}
				},
				{
					path: '/assets/assetDispose',
					name: 'AssetDisposeIndex',
					icon: '',
					component: () => import('@/views/assets/assetDispose/index'),
					power: 'admin/v1/assetDispose',
					meta: {
						title: '资产处置'
					}
				},
				{
					path: '/assets/assetRepair',
					name: 'assetRepairIndex',
					icon: '',
					component: () => import('@/views/assets/assetRepair/index'),
					power: 'admin/v1/assetRepair',
					meta: {
						title: '资产报修'
					}
				},
				{
					path: '/assets/assetMaintain',
					name: 'assetMaintain',
					icon: '',
					component: () => import('@/views/assets/assetMaintain/index'),
					power: 'admin/v1/assetMaintain',
					meta: {
						title: '资产维修'
					}
				},
				{
					path: '/assets/assetStatistics',
					name: 'AssetStatisticsIndex',
					icon: '',
					component: () => import('@/views/assets/assetStatistics/index'),
					power: 'admin/v1/assetStatistics',
					meta: {
						title: '资产统计'
					}
				},
				{
					path: '/assets/settingSort',
					name: 'assetSortIndex',
					icon: '',
					component: () => import('@/views/assets/setting/sort'),
					power: 'admin/v1/settingSort',
					meta: {
						title: '分类管理'
					}
				}
			]
		},
		{
			path: '/',
			icon: '',
			meta: {
				title: '耗材管理'
			},
			children: [
				{
					path: '/consumable/archives',
					name: 'archivesIndex',
					icon: '',
					component: () => import('@/views/consumable/archives/index'),
					meta: {
						title: '耗材档案'
					},
					power: 'admin/v1/kq/plan'
				},
				{
					path: '/consumable/inventory',
					name: 'InventoryIndex',
					icon: '',
					component: () => import('@/views/consumable/inventory/index'),
					meta: {
						title: '实时库存'
					},
					power: 'admin/v1/kq/plan'
				},
				{
					path: '/consumable/receive',
					name: 'consumableReceiveIndex',
					icon: '',
					component: () => import('@/views/consumable/receive/index'),
					power: 'admin/v1/kq/plan',
					meta: {
						title: '领用申请'
					}
				},
				{
					path: '/consumable/stash',
					name: 'StashIndex',
					icon: '',
					component: () => import('@/views/consumable/stash/index'),
					power: 'admin/v1/kq/plan',
					meta: {
						title: '分类管理'
					}
				},
				{
					path: '/consumable/putStorage',
					name: 'putStorage',
					icon: '',
					component: () => import('@/views/consumable/putStorage/index'),
					power: 'admin/v1/kq/plan',
					meta: {
						title: '耗材入库'
					}
				},
				{
					path: '/consumable/outQuit',
					name: 'ConsumableOut',
					icon: '',
					component: () => import('@/views/consumable/outQuit/index'),
					power: 'admin/v1/kq/plan',
					meta: {
						title: '耗材出库'
					}
				},
				{
					path: '/consumable/adjust',
					name: 'consumableAdjust',
					icon: '',
					component: () => import('@/views/consumable/adjust/index'),
					power: 'admin/v1/kq/plan',
					meta: {
						title: '耗材调整'
					}
				},
				{
					path: '/consumable/allot',
					name: 'consumableAllotView',
					icon: '',
					component: () => import('@/views/consumable/allot/index'),
					power: 'admin/v1/kq/plan',
					meta: {
						title: '耗材调拨'
					}
				},
				{
					path: '/consumable/breakage',
					name: 'consumableBreakage',
					icon: '',
					component: () => import('@/views/consumable/breakage/index'),
					power: 'admin/v1/kq/plan',
					meta: {
						title: '耗材报损'
					}
				}
			]
		},
		{
			path: '/',
			icon: '',
			component: '',
			meta: {
				title: '品牌管理'
			},
			children: [
				{
					path: '/assets/brand',
					name: 'BrandIndex',
					icon: '',
					component: () => import('@/views/assets/setting/brand/index'),
					power: 'admin/v1/brand',
					meta: {
						title: '品牌'
					}
				}
			]
		},
		{
			path: '/',
			icon: '',
			component: '',
			meta: {
				title: '仓库管理'
			},
			children: [
				{
					path: '/assets/setting/storeSetting',
					name: 'assetsStoreSettingIndex',
					icon: '',
					component: () => import('@/views/assets/setting/storeSetting/index'),
					power: 'admin/v1/brand',
					meta: {
						title: '仓库'
					}
				}
			]
		},
		{
			path: '/',
			icon: '',
			meta: {
				title: '档案管理'
			},
			children: [
				{
					path: '/archives/school',
					name: 'StoreSettingIndex',
					icon: '',
					component: () => import('@/views/assets/archivesManage/school/index'),
					power: 'admin/v1/brand',
					meta: {
						title: '学习中心档案'
					}
				}
			]
			}
		// {
		//   path: "/fixedAssets/asset",
		//   icon: "ChatLineSquare",
		//   component: () => import("@/views/fixedAssets/asset"),
		//   power: "admin/v1/asset",
		//   meta: {
		//     title: "资产列表",
		//   }
		// },
		// {
		//   path: "/fixedAssets/collect",
		//   icon: "ChatLineSquare",
		//   component: () => import("@/views/fixedAssets/collect"),
		//   power: "admin/v1/collect",
		//   meta: {
		//     title: "领用",
		//   }
		// },
		// {
		//   path: "/fixedAssets/repair",
		//   icon: "ChatLineSquare",
		//   component: () => import("@/views/fixedAssets/repair"),
		//   power: "admin/v1/repair",
		//   meta: {
		//     title: "维修登记",
		//   }
		// },
		// {
		//   path: "/fixedAssets/returnInventory",
		//   icon: "ChatLineSquare",
		//   component: () => import("@/views/fixedAssets/returnInventory"),
		//   power: "admin/v1/returnInventory",
		//   meta: {
		//     title: "借用归还",
		//   }
		// },
		// {
		//   path: "/fixedAssets/cleanUp",
		//   icon: "ChatLineSquare",
		//   component: () => import("@/views/fixedAssets/cleanUp"),
		//   power: "admin/v1/cleanUp",
		//   meta: {
		//     title: "清理报废",
		//   }
		// },
		// {
		//   path: "/fixedAssets/borrowReturn",
		//   icon: "ChatLineSquare",
		//   component: () => import("@/views/fixedAssets/borrowReturn"),
		//   power: "admin/v1/borrowReturn",
		//   meta: {
		//     title: "退库",
		//   }
		// },
		// {
		//   path: '/',
		//   icon: 'setting',
		//   component: '',
		//   meta: {
		//     title: '设置'
		//   },
		//   children: [
		//     {
		//       path: '/fixedAssets/setting/source',
		//       icon: '',
		//       component: () => import('@/views/fixedAssets/setting/source'),
		//       power: 'admin/v1/source',
		//       meta: {
		//         title: '来源'
		//       }
		//     },
		//     {
		//       path: '/fixedAssets/setting/encoding',
		//       icon: '',
		//       component: () => import('@/views/fixedAssets/setting/encoding'),
		//       power: 'admin/v1/encoding',
		//       meta: {
		//         title: '资产编码规则'
		//       }
		//     },
		//     {
		//       path: '/fixedAssets/setting/classification',
		//       icon: '',
		//       component: () => import('@/views/fixedAssets/setting/classification'),
		//       power: 'admin/v1/classification',
		//       meta: {
		//         title: '资产分类'
		//       }
		//     },
		//   ]
		// }
	]
}
